import { Component, EventEmitter, Input, Optional, Output } from "@angular/core";

@Component({
  selector: "app-navigation-element",
  templateUrl: "./navigation-element.component.html",
  styleUrls: ["./navigation-element.component.scss"],
})
export class NavigationElementComponent {
  /** Route to navigate to. Without one, the element emits `selected` instead */
  @Input() route?: string;
  @Input() disabled = false;
  @Input() title = "";
  @Optional() @Input() subtitle = "";
  @Input() icon!: string | undefined;
  @Input() opensNewTab = false;
  @Output() selected = new EventEmitter<void>();

  /**
   * Notify that the element was selected, for an element running an action rather than navigating to a route
   */
  select(): void {
    if (!this.route && !this.disabled) {
      this.selected.emit();
    }
  }
}
